// metadata action types
export const SET_SONG_ATTRIBUTES = 'SET_SONG_ATTRIBUTES';

export default {
  SET_SONG_ATTRIBUTES
};
